import axios from "axios";
import { apiUrl, PORT } from "../../environment";
import { toast } from "react-toastify";
import axiosClient from "../../admin/services/axiosClient";

export const fetchNOtificationApi = (data, callback, dispatch) => {
  try {
    //   dispatch(loadingAction(true));
    return axios
      .get(`${apiUrl}${PORT}/patient-service/notifications`)
      .then((response) => {
        //   dispatch(loadingAction(false));
        // callback(response.data);
        return response;
      })
      .catch((error) => {
        //   dispatch(loadingAction(false));
        // callback(false);            
        return error
      });
  } catch (err) {
  }
};




export const uploadMessageImage = async (data, token) => {
  try {


    // Await the response from the API call
    // const response = await axios.post(
    //   `${apiUrl}${PORT}/patient-service/upload-message-image`, data ,
    //  { 
    //   options}
    // );


    const response = await axiosClient.post(`/patient-service/upload-message-image`, data);

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }


  } catch (err) {
    toast.error("An error occurred while fetching patients");
  }
};